<template>
	<div class="mockup">
		<div class="mockup-wrap" :class="{hide: loading}" v-if="frame">
			<img
				class="frame"
				:src="frame"
				:style="{maxHeight, height: firefox ? maxHeight : null, padding}"
			/>
			<!-- <img class="frame overlay" :src="overlay.img" :style="{maxHeight, height: (firefox ? maxHeight : null), padding}"> -->

			<div class="screenshot" :style="{margin: padding}">
				<div
					class="screenshot-overlay"
					v-if="overlay"
					:style="{backgroundImage: `url('${overlay.img}')`}"
				/>

				<div
					class="screenshot-wrap"
					:style="{top: pos[0], right: pos[1], bottom: pos[2], left: pos[3]}"
				>
					<div
						class="screenshot-img"
						:class="mode"
						:style="{
							border,
							borderRadius,
							backgroundImage: `url('${image}')`
						}"
					/>
				</div>

				<div
					class="screenshot-bar"
					v-if="bar"
					:style="{
						top: bar.pos[0],
						right: bar.pos[1],
						bottom: bar.pos[2],
						left: bar.pos[3]
					}"
				>
					<img :src="bar.img" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {type: Object, required: true},
		single: {type: Boolean},
		maxHeight: String,
		padding: String,
		thumb: Boolean
	},
	data() {
		return {
			loading: false,
			frame: null,
			pos: []
		};
	},
	computed: {
		overlay: (t) => t.item.overlay,
		image: (t) => t.$store.state.file,
		mode: (t) => t.$store.state.mode,
		bar: (t) => t.item.bar,
		style: (t) => t.item.styles.find((x) => x.active),
		color: (t) => t.style.colors.find((x) => x.active),
		border: (t) => t.item.border,

		borderRadius() {
			return this.thumb
				? this.item.borderRadiusThumb || this.item.borderRadius
				: this.item.borderRadius;
		},

		firefox() {
			return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
		}
	},
	methods: {
		load() {
			this.loading = true;
			const frame = new Image();
			frame.src =
				this.thumb && this.color.thumb ? this.color.thumb : this.color.img;
			frame.onload = () => {
				setTimeout(() => {
					this.pos = this.style.pos;
					this.frame = frame.src;
					this.loading = false;
					this.$emit("loaded");
				}, 250);
			};
		}
	},
	created() {
		this.$watch("color", this.load, {immediate: true});
	}
};
</script>

<style lang="scss" scoped>
.mockup {
	display: flex;
	max-height: inherit;
	max-width: inherit;
	justify-content: center;
	align-items: center;

	&-wrap {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		position: relative;
		max-width: inherit;
		max-height: inherit;
		transition: opacity 0.2s ease-in-out;
		&.hide {
			opacity: 0;
		}
	}
}
.frame {
	max-width: 100%;
	max-height: inherit;
	display: flex;
	flex-wrap: wrap;
	// box-sizing: content-box;
	// filter:
	//   drop-shadow(0 2px 30px rgba(0,0,0,0.12))
	//   drop-shadow(0 2px 12px rgba(0,0,0,0.08))
	//   drop-shadow(0 2px 8px rgba(0,0,0,0.24));

	&.overlay {
		position: absolute;
	}

	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
		width: 100%;
	}
	@supports (-ms-ime-align: auto) {
		width: 100%;
	}
}
.screenshot {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;

	&-wrap {
		position: absolute;
	}

	&-overlay {
		z-index: 1;
		background-repeat: no-repeat;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-size: cover;
	}

	&-img {
		background-color: $black1;
		border: 0.05em solid $black1;
		background-repeat: no-repeat;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;

		&.cover {
			background-position: top left;
			background-size: 100%;
		}

		&.fill {
			background-position: top;
			background-size: cover;
		}

		&.contain {
			background-position: top;
			background-size: contain;
		}

		&.stretch {
			background-size: 100% 100%;
		}
	}

	&-bar {
		position: absolute;
		display: flex;
		align-items: flex-start;

		img {
			width: 100%;
		}
	}
}

.loading {
	box-sizing: content-box;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	display: flex;
	align-items: center;
	justify-content: center;
}

.spinner {
	width: 2em;
	height: 2em;
	position: relative;
	margin-top: 6em;

	.double-bounce1,
	.double-bounce2 {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: $color1;
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;
		animation: sk-bounce 2s infinite ease-in-out;
	}

	.double-bounce2 {
		animation-delay: -1s;
	}
}

@keyframes sk-bounce {
	0%,
	100% {
		transform: scale(0);
	}
	50% {
		transform: scale(1);
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.25s ease;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
